import chevironRight from "$/cheviron-right.svg";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import { LayoutHeader } from "@/Header";
import { useContractHistoryForUser } from "~/services/common/contractHistory";
import type { ContractHistoryItem } from "~/types/common";

export const Route = createFileRoute("/customer/layout/user-contract")({
  component: User,
});

const formatDate = (iso: string | null): string => {
  if (!iso) return "-";
  const str = typeof iso === "string" ? iso : String(iso);
  return str.replace("T", " ").slice(0, 10).replace(/-/g, ".");
};

const statusBadgeColor = (status: ContractHistoryItem["status"]): string => {
  switch (status) {
    case "COMPLETED":
      return "bg-green-50 text-green-700 border-green-200";
    case "PENDING":
      return "bg-blue-50 text-blue-700 border-blue-200";
    case "REJECTED":
      return "bg-red-50 text-red-700 border-red-200";
    case "EXPIRED":
      return "bg-gray-100 text-gray-600 border-gray-200";
    case "CANCELED":
      return "bg-gray-100 text-gray-500 border-gray-200";
    default:
      return "bg-gray-50 text-gray-600 border-gray-200";
  }
};

/** 상세 페이지 경로 — source 분기 (레거시는 기존 라우트 호환 유지). */
const buildDetailHref = (item: ContractHistoryItem): string => {
  if (item.source === "LEGACY") {
    return `/customer/layout/user-contract-detail?histContrSeq=${item.itemSeq}`;
  }
  return `/customer/layout/user-contract-detail?requestSeq=${item.itemSeq}&source=REQUEST`;
};

function User() {
  const { history } = useRouter();
  const { data: listResp } = useContractHistoryForUser({ page: 1, size: 50 });
  const items: ContractHistoryItem[] = listResp?.data?.content ?? [];

  return (
    <>
      <LayoutHeader title={"계약서 조회"} hasBackBtn hasFootPrint={false} />
      <div className="flex flex-col flex-auto bg-[#F5F5F5]">
        <div className="flex flex-col flex-auto gap-4 px-5 pt-5 rounded-t-3xl">
          <div className="">
            {items.length === 0 && (
              <div className="text-center text-[13px] text-[#999] mt-10">
                표시할 계약 내역이 없습니다.
              </div>
            )}

            {items.map((item) => (
              <div
                key={`${item.source}-${item.itemSeq}`}
                className="bg-white border-2 border-[#E9E9E9] rounded-xl mb-2"
              >
                <button
                  className="flex justify-between items-center px-4 py-3 w-full text-left"
                  onClick={() => history.push(buildDetailHref(item))}
                >
                  <div className="flex flex-col">
                    <span className="text-[14px] text-[#333]">
                      {item.companyName ?? "-"}{" "}
                      <span className="text-[#888]">({item.petName ?? "-"})</span>
                    </span>
                    <span className="text-[12px] text-[#999] mt-[2px]">
                      {item.contractName ?? "위탁계약서"} ·{" "}
                      {formatDate(item.dtSigned ?? item.dtSent ?? item.dtRegist)}
                    </span>
                  </div>
                  <div className="flex gap-2 items-center">
                    <span
                      className={`inline-block px-2 py-[2px] rounded-full text-[11px] border ${statusBadgeColor(item.status)}`}
                    >
                      {item.statusLabel}
                    </span>
                    <img src={chevironRight} alt="상세 보기" />
                  </div>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
